// What a unit puts out, as the cards show it: each weapon's basic-attack damage, and each of its abilities' output
// (damage, healing, or a hit %), computed the way inlineUnit.vue does with no tuning: against a generic 60-Faith target,
// before the target's evasion, elements and zodiac. A monster's abilities are its own kit (gd.monsterSkills); a
// human's are its class and secondary skills. Pure: `gd` = { charStats, itemschanged, notAbles, abilitiesInfo,
// monsterSkills }. For the hover (lib/unitTip.js).
import { unitCombatStats } from './unitStats.js';
import { weaponDamage, unarmedDamage } from './damage.js';
import { unitElementProfile } from './elements.js';
import { abilityDisplay, legacyAbilityFormula } from './abilityFormula.js';

export const GENERIC_FAITH = 60;

export function unitOutput(u, gd) {
  const { equipped, stats, paUnarmed } = unitCombatStats(u, gd.charStats, gd.itemschanged, gd.notAbles);
  const strengthen = unitElementProfile(equipped).strengthen;
  const sup = u.SupportSkill || '';
  const attackUp = sup === 'Attack Up', magicAttackUp = sup === 'Magic Attack Up';
  const martialArts = sup === 'Martial Arts' || u.Class === 'Monk';
  const swing = (slot, plus = 0) => {
    const item = equipped[slot];
    if (!item || !item.type || item.type === 'Shield') return null;
    const d = weaponDamage({ item, pa: stats.pa + plus, ma: stats.ma, speed: stats.speed, brave: u.Brave, faith: u.Faith,
      doublehand: sup === 'Doublehand', targetFaith: GENERIC_FAITH, attackUp, magicAttackUp, strengthen });
    return d == null ? null : String(d);
  };
  const unarmed = (plus = 0) => String(unarmedDamage({ paUnarmed: paUnarmed + plus, brave: u.Brave, isMartialArts: martialArts, attackUp }));

  const weapons = [];
  if (u.Gender !== 'Monster') {
    if (u.Mainhand) { const d = swing('Mainhand'); weapons.push({ name: u.Mainhand, out: d }); } else weapons.push({ name: 'Unarmed', out: unarmed() });
    if (u.Offhand && equipped.Offhand.type !== 'Shield') { const d = swing('Offhand'); if (d != null) weapons.push({ name: u.Offhand, out: d }); }
  }

  const ctx = { ma: stats.ma, pa: stats.pa, speed: stats.speed, brave: u.Brave, faith: u.Faith, targetFaith: GENERIC_FAITH,
    wp: equipped.Mainhand.wp, maxHp: stats.hp, paUnarmed };
  const mods = { strengthen, attackUp, magicAttackUp, martialArts };
  const one = (name) => {
    const charge = /^Charge\+(\d+)$/.exec(name);
    if (charge) return u.Mainhand ? swing('Mainhand', +charge[1]) : unarmed(+charge[1]);
    const info = gd.abilitiesInfo && gd.abilitiesInfo[name];
    const parsed = info ? abilityDisplay(info, ctx, mods) : '';
    if (parsed) return parsed;
    const legacy = legacyAbilityFormula(name, { ...ctx, weaponType: equipped.Mainhand.type });
    return legacy ? legacy.display : '';
  };
  const mon = u.Gender === 'Monster' && gd.monsterSkills && gd.monsterSkills[u.Class];
  const names = mon ? mon.map((n) => n.replace(/\*$/, '')) : [...(u.ClassSkills || []), ...(u.ExtraSkills || [])];
  const abilities = names.map((name) => ({ name, out: one(name) || '' }));
  return { stats, equipped, weapons, abilities };
}
